module.exports = __webpack_public_path__ + "images/questions/qa_member_user_tag_dda21198f2e0409aea408b43ee8779fb.png";